import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const FeedbackOverlay = ({ feedback, visible }) => {
  const getFeedbackConfig = (type) => {
    const configs = {
      perfect: { text: 'PERFECT!', color: 'text-accent', glow: 'shadow-neon-green' },
      excellent: { text: 'EXCELLENT!', color: 'text-primary', glow: 'shadow-neon-blue' },
      good: { text: 'GOOD!', color: 'text-secondary', glow: 'shadow-neon-pink' },
      nice: { text: 'NICE!', color: 'text-primary', glow: 'shadow-neon-blue' },
      awesome: { text: 'AWESOME!', color: 'text-accent', glow: 'shadow-neon-green' }
    };
    return configs[type] || configs.good;
  };

  const config = getFeedbackConfig(feedback);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 1.5, opacity: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="absolute inset-0 flex items-center justify-center pointer-events-none"
          data-testid="feedback-overlay"
        >
          <div className={`font-heading text-6xl md:text-8xl font-black uppercase tracking-tighter ${config.color} ${config.glow}`}>
            {config.text}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FeedbackOverlay;
